import { Box, Grid, Stack, styled } from '@ltvco/refresh-lib/theme';

export const StickyContainer = styled(Stack)(({ theme }) => ({
  position: 'fixed',
  top: 60,
  width: '100%',
  zIndex: 2,

  [theme.breakpoints.up('md')]: {
    zIndex: 1,
    marginBottom: theme.spacing(3),
    height: 'unset',
    overflowY: 'unset',
    position: 'sticky',
  },
}));

export const ConsolidatedStickyContainer = styled(Stack)(({ theme }) => ({
  position: 'fixed',
  top: 58,
  width: '100%',
  zIndex: 2,
  left: 0,

  [theme.breakpoints.up('md')]: {
    top: 0,
    paddingTop: 16,
    zIndex: 1,
    marginBottom: theme.spacing(3),
    height: 'unset',
    overflowY: 'unset',
    position: 'sticky',
    maxWidth: '400px',
    minWidth: '220px',
  },
}));

export const PersonFilterNav = styled('ul')(({ theme }) => ({
  listStyle: 'none',
  display: 'flex',
  margin: theme.spacing(0.5, 0.5, 2.5),
  padding: 0,
  position: 'relative',
  top: '50px',
  height: '90px',
  [theme.breakpoints.up('md')]: {
    position: 'unset',
    height: 'unset',
    top: 0,
  },
  '&.search-nav': {
    [theme.breakpoints.up('md')]: {
      gap: theme.spacing(4),
    },
  },
}));

export const PersonFilterNavItem = styled('li')(({ theme }) => ({
  float: 'left',
  position: 'relative',
  display: 'block',
  paddingTop: theme.spacing(0.375),
  ':hover,&.active': {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    '.selected-tab': {
      display: 'block',
    },
  },
  '.selected-tab': {
    display: 'none',
  },
}));

export const NavButton = styled('button')(({ theme }) => ({
  backgroundColor: 'transparent',
  color: theme.palette.text.secondary,
  padding: theme.spacing(0.5, 1),
  borderRadius: '32px',
  border: `1px solid ${theme.palette.grey[300]}`,
  cursor: 'pointer',
  '-webkit-tap-highlight-color': 'transparent',
  '-webkit-appearance': 'none',
  '-moz-appearance': 'none',
  appearance: 'none',

  ':hover': {
    backgroundColor: theme.palette.background.default,
  },

  ':focus': {
    outline: 'none',
    backgroundColor: 'transparent',
  },

  ':active': {
    backgroundColor: 'transparent',
    color: 'inherit',
    opacity: 1,
  },

  '&.active': {
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    '.options-results': {
      backgroundColor: theme.palette.primary.main,
    },
  },

  '&.disabled': {
    opacity: 0.35,
  },

  '&.filters-button': {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
}));

export const OptionResults = styled('div')(({ theme }) => ({
  height: '25px',
  width: '25px',
  backgroundColor: theme.palette.text.secondary,
  borderRadius: '50px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: theme.palette.common.white,
}));

export const SearchHeader = styled(Stack)(({ theme }) => ({
  position: 'sticky',
  top: '52px',
  zIndex: 2,
  backgroundColor: theme.palette.primary.contrastText,
  left: 0,
  right: 0,
  marginLeft: '-1vw',
  paddingLeft: '100px',

  [theme.breakpoints.between('md', 'lg')]: {
    padding: '15px 24px',
  },

  [theme.breakpoints.up('md')]: {
    top: '52px',
    padding: '15px',
    paddingLeft: '0',
    marginLeft: '0',
  },

  [theme.breakpoints.between(1070, 'xl')]: {
    top: '52px',
  },

  [theme.breakpoints.up('xl')]: {
    top: '52px',
  },
}));

export const SearchHeaderVariation = styled(Stack)(({ theme }) => ({
  position: 'sticky',
  top: '52px',
  zIndex: 2,
  backgroundColor: theme.palette.background.default,
  left: 0,
  right: 0,
  marginLeft: '-1vw',
  paddingLeft: '100px',

  [theme.breakpoints.down('sm')]: {
    paddingLeft: '15px',
    minWidth: '100%',
    padding: theme.spacing(1),
    top: '70px',
  },

  [theme.breakpoints.up('md')]: {
    top: '52px',
    paddingX: '15px',
    paddingLeft: '0',
    marginLeft: '0',
  },

  [theme.breakpoints.between(1070, 'xl')]: {
    top: '52px',
  },

  [theme.breakpoints.up('xl')]: {
    top: '52px',
  },
}));

export const BoxCardContainer = styled(Box)(({ theme }) => ({
  marginTop: '16px',
  zIndex: 1,
  marginLeft: '20px',
  width: '100%',

  [theme.breakpoints.up('md')]: {
    width: '72%',
    marginTop: '0',
  },
}));

export const PersonFiltersContainer = styled(Grid)(() => ({}));

export const ResultsContainer = styled(Grid)(({ theme }) => ({
  marginLeft: 0,
  position: 'relative',
  zIndex: 0,
  willChange: 'width',
  transition: 'all 0.3s ease-in-out',
  flex: 1,

  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const SearchResultsGrid = styled(Grid)(({ theme }) => ({
  marginTop: 0,
  position: 'relative',
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
  padding: 0,
  maxWidth: '100%',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },

  [theme.breakpoints.up('xl')]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(2),
  },

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },

  '& .MuiGrid-item': {
    paddingTop: 0,
  },
}));

export const SearchbotStickyContainer = styled(Stack)(
  ({ isChatbotOpen }: { isChatbotOpen: boolean }) => ({
    top: 60,
    zIndex: 1,
    alignSelf: 'flex-start',
    height: 'calc(100vh - 65px)',
    position: isChatbotOpen ? 'sticky' : 'fixed',
    transform: isChatbotOpen ? 'translateX(0)' : 'translateX(100%)',
    opacity: isChatbotOpen ? 1 : 0,
    flexDirection: 'column',
    m: 0,
    p: 1,
    transition: 'all 0.3s ease-in-out',
    width: '100%',
  })
);

export const SearchbotSizebleContainer = styled(Stack)(
  ({ isChatbotOpen }: { theme: any; isChatbotOpen: boolean }) => ({
    minWidth: isChatbotOpen ? '300px' : '0',
    maxWidth: isChatbotOpen ? '400px' : '0',
    height: '100%',
    flexShrink: 1,
    overflow: isChatbotOpen ? 'visible' : 'hidden',
    transition: 'all 0.3s ease-in-out',
    margin: isChatbotOpen ? '20px 0 20px 20px' : '0',
    padding: '0',
  })
);
